/* RESPONSIBLE TEAM: team-standalone */

import type { ConversationExtractionRowData } from '../definitions';
import type SalesforcePlatform from '../../salesforce';

export default class SalesforceConversationExtractionRow implements ConversationExtractionRowData {
  private platform: SalesforcePlatform;

  constructor(platform: SalesforcePlatform) {
    this.platform = platform;
  }

  get icon() {
    return 'salesforce' as const;
  }

  get title() {
    if (this.platform.salesforceConfig?.isConnected) {
      return this.platform.salesforceConfig?.domain ?? '';
    }
    return this.platform.intl.t(
      'knowledge-hub.overview.sections.conversation-extraction.rows.active.title.salesforce',
    );
  }
}
